module.exports = __webpack_public_path__ + "img/618.9e313de7.png";